var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2857 7.14309C16.2857 6.00645 15.8342 4.91636 15.0305 4.11263C14.2267 3.30891 13.1366 2.85738 12 2.85738C10.8634 2.85738 9.77327 3.30891 8.96954 4.11263C8.16582 4.91636 7.71429 6.00645 7.71429 7.14309C7.71429 8.27973 8.16582 9.36982 8.96954 10.1736C9.77327 10.9773 10.8634 11.4288 12 11.4288C13.1366 11.4288 14.2267 10.9773 15.0305 10.1736C15.8342 9.36982 16.2857 8.27973 16.2857 7.14309ZM5.14286 7.14309C5.14286 5.32447 5.8653 3.58032 7.15127 2.29436C8.43723 1.0084 10.1814 0.28595 12 0.28595C13.8186 0.28595 15.5628 1.0084 16.8487 2.29436C18.1347 3.58032 18.8571 5.32447 18.8571 7.14309C18.8571 8.96172 18.1347 10.7059 16.8487 11.9918C15.5628 13.2778 13.8186 14.0002 12 14.0002C10.1814 14.0002 8.43723 13.2778 7.15127 11.9918C5.8653 10.7059 5.14286 8.96172 5.14286 7.14309ZM2.64107 25.1431H21.3589C20.8821 21.752 17.9679 19.1431 14.4482 19.1431H9.55179C6.03214 19.1431 3.11786 21.752 2.64107 25.1431ZM0 26.1234C0 20.8467 4.275 16.5717 9.55179 16.5717H14.4482C19.725 16.5717 24 20.8467 24 26.1234C24 27.002 23.2875 27.7145 22.4089 27.7145H1.59107C0.7125 27.7145 0 27.002 0 26.1234Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d5b4a647650fcc6b36800269aee344e3.svg";
export { ForwardRef as ReactComponent };